export default __webpack_public_path__ + "static/media/rec.cfa26037.png";